// move the constants here so that they can be shared across the app without circular imports

export const TAX_TREATMENT_ID = {
  NONE: 0
};